import { lazy } from '../../lazy';
import { changeLocaleAndUpdate, defaultLocaleCode } from './i18n';
export class I18nManager {
    constructor() {
        this.i18nSettings = lazy(() => this.context.settings.getSetting('i18n', defaultLocaleCode));
    }
    async init(context) {
        this.context = context;
        const settingsValue = this.i18nSettings.value.value ?? defaultLocaleCode;
        await changeLocaleAndUpdate(settingsValue);
    }
    async changeLocale(localeCode) {
        this.i18nSettings.value.setValue(localeCode);
        return await changeLocaleAndUpdate(localeCode);
    }
}
//# sourceMappingURL=i18n-controller.js.map